import { USTreasuriesState } from './state';
import { USTreasuriesActionsUnion, USTreasuriesActionTypes } from './actions';
import { USTreasury } from '../../types/treasuries.types';

export const userPreferencesDefaultState: USTreasuriesState = {
  treasuries: undefined,
  loaded: false,
  loading: false,
  error: undefined
};

export function usTreasuriesReducer(
  state = userPreferencesDefaultState,
  action: USTreasuriesActionsUnion
): USTreasuriesState {
  switch (action.type) {
    case USTreasuriesActionTypes.Load:
      return {
        ...state,
        treasuries: undefined,
        loading: true,
        loaded: false,
        error: undefined
      };
    case USTreasuriesActionTypes.LoadSuccess:
      return {
        ...state,
        treasuries: action.payload,
        loaded: true,
        loading: false
      };
    case USTreasuriesActionTypes.LoadFail:
      return {
        ...state,
        loaded: false,
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
}

export const getUSTreasuries = (
  treasuriesState: USTreasuriesState
): USTreasury[] => {
  return treasuriesState.treasuries;
};
